import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./documentHandler.sass";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import rgIcon from './../images/document_type.svg'
import cnhIcon from './../images/document_type_cnh.svg'
import { apiUser } from "../basedata/apiCall";
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import ModalInfo from "../components/Modal/ModalInfo";

const DocumentHandler = () => {
  const { t } = useTranslation(); 
  const navigate = useNavigate();


  const documentHandlerUrl = () => {
    window.location.href = '/mobile-document'
  }


  const [error, setError] = useState<string | null>(null);

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (file.type !== 'application/pdf') {
      setError('Please upload a valid PDF file.');
      return;
    }

    setError(null);

    const formData = new FormData();
    formData.append('file', file);

    setIsLoading(true)

    try {

      const base64 = await fileToBase64(file);

      const _request  = await apiUser.post('/biometry/create/document/upload', {
        originToken: sessionStorage.getItem('token') || 'na',
        document: base64,
      });

      const _validate_doc = await apiUser.post(`/biometry/flow/user-jorney`, {flowId: sessionStorage.getItem('token') || 'na'})

      if(
        _validate_doc?.data.status === 'success' &&
        _validate_doc?.data.message === 'done'){
          return window.location.href = '/success'
        }

      if(
        _validate_doc?.data.validation === 'failed'){
          setIsLoading(false)
          return setIsSuccessModalOpen(true)
        }

        setIsLoading(false)
        return setIsSuccessModalOpen(true)
        // return window.location.href = '/waiting'


    } catch (err: any) {
      console.error(err);
      setIsLoading(false)
      setIsSuccessModalOpen(true)
      // setError('Failed to process the PDF.');
    }
  };

  const fileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(file); // includes data:application/pdf;base64,...
    });
  };


  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false)
  const [loadingProgress, setLoadingProgress] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const closeModal = () => {
    documentHandlerUrl();
    // setIsSuccessModalOpen(false);
  };

  
  return (

          isLoading ? (
        <div className="loader">
        <div className="spinner">
        </div>
        </div>
      ):(
    <div className="welcome-card">
    <h1 className="bepass-title">{t('document_upload_choose.title')}</h1>
    <p className="bepass-text-default">
    {t('document_upload_choose.quote')}<br/>
    {t('document_upload_choose.text_1')} <strong>{t('document_upload_choose.cnh_digital')}</strong> {t('document_upload_choose.text_2')}
    </p>



    <ul className="document-type-select">
      <li>
        <i>
          <UploadFileOutlinedIcon />
        </i>
        <Box
          className="type-select-description"
          onClick={() => document.getElementById('file-sender')?.click()}
        >
          <h2 className="bepass-title">{t('document_upload_choose.cnh_digital')}</h2>
          <input
            id="file-sender"
            type="file"
            accept="application/pdf"
            onChange={handleFileChange}
            style={{ display: 'none' }}
            onClick={e => e.stopPropagation()} // Prevent Box click when input is clicked
          />
          <p className="bepass-text-label">{t('document_upload_choose.cnh_digital_text')}</p>
        </Box>
        {error && <p style={{ color: 'red' }}>{error}</p>}
      </li>


      <li onClick={() => documentHandlerUrl()}>
        <i>
          <CameraAltOutlinedIcon />
        </i>
        <Box className="type-select-description">
          <h2 className="bepass-title">{t('document_upload_choose.capture_document')}</h2>
          <p className="bepass-text-label">{t('document_upload_choose.capture_document_text')}</p>
        </Box>
      </li>
    </ul>

    <ModalInfo isOpen={isSuccessModalOpen} onClose={closeModal}>
        <img src="/document_svg.svg" alt="icone documento"/>
        <h1>{t("modal_document_handler.title")}</h1>
        <p>{t("modal_document_handler.quote")}</p>
        <button className="btn_send_document" onClick={() => documentHandlerUrl()}>
            {/* <img src={document} alt="icone documento"/> */}
            <span>{t("modal_document_handler.call_to_action")}</span>
        </button>
    </ModalInfo>
  </div>
  )
  );
};

export default DocumentHandler;
